{
  "carrierLabel": "Perusahaan pengangkut",
  "searchPlaceholder": "Cari berdasarkan nama",
  "selectAsCarrier": "Pilih \"{name}\" sebagai Pengangkut",
  "typeToSearch": "Ketik untuk mencari perusahaan"
}
